import moment from "moment";
import DateTimeUtils from "./DateTimeUtils";

export default class StringUtils {

  static toTitleCase(str) {
    if (!str) return str;

    var result = str.replaceAll('_', ' ').toLowerCase().replace(/\b[a-z]/g, function (char) {
      return char.toUpperCase();
    });

    return result.includes(' Id') || result.includes(' Ids') ? result.replace(' Ids', '').replace(' Id', '') : result;
  }

  static toTitleCase2(str) {
    if (!str) return str;

    var result = str.replaceAll('_', ' ').toLowerCase().replace(/\b[a-z]/g, function (char) {
      return char.toUpperCase();
    });

    return result;
  }

  static validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  }

  static getParameterByName(name, url) {
    name = name.replace(/\[|\]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static getFileExtension(name, url) {
    var valueUrl = StringUtils.getParameterByName(name, url);
    return valueUrl.substr(valueUrl.lastIndexOf('.'));
  }

  static getFileNameExtension(fileName) {
    return fileName.substr(fileName.lastIndexOf('.') + 1);
  }

  static isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  static localDate(date) {
    if (!date) return null;
    const m = moment(date, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss"], true);
    return m.isValid() ? m.local() : null;
  }

  static formatDate(date) {
    if (!date) return "";

    if (!isNaN(date) && String(date).length <= 8) {
      return String(date);
    }

    const m = this.localDate(date);
    return m && m.isValid() ? m.format("DD-MMM-YYYY") : String(date);
  }

  static formatDateTime(dateTime) {
    return DateTimeUtils.formatDisplayDateTime(dateTime, null, true);
  }

  static formatSSN(ssn) {
      const cleaned = ssn.replace(/\D/g, '');

      const match = cleaned.match(/^(\d{3})(\d{2})(\d{4})$/);

      if (match) {
          return `${match[1]}-${match[2]}-${match[3]}`;
      }

      return ssn;
  }
}
